module.exports = __webpack_public_path__ + "img/correctspelling.91c63bfd.jpg";